"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _sortBy = _interopRequireDefault(require("lodash/sortBy"));
var _lowerCase = _interopRequireDefault(require("lodash/lowerCase"));
var _utils = require("../../../utils");
var _styled = require("../../base/styled");
var _styled2 = require("../../inputs/text-box/styled");
var _styled3 = require("../../buttons/custom-button/styled");
var _ = require("../..");
var _constant = require("../../../constant");
var _opportunityLocation = _interopRequireDefault(require("../opportunity-location"));
var _styled4 = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var OpportunityBanner = function OpportunityBanner(_ref) {
  var _opportunity$company;
  var opportunity = _ref.opportunity,
    editable = _ref.editable,
    fontStyle = _ref.fontStyle,
    onEditBanner = _ref.onEditBanner,
    onEditLogo = _ref.onEditLogo,
    company = _ref.company,
    showCompanyName = _ref.showCompanyName,
    goToCompany = _ref.goToCompany,
    durationsBand = _ref.durationsBand;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showTitle = _useState2[0],
    setShowTitle = _useState2[1];
  var industries = opportunity.industries.map(function (industry) {
    return industry === null || industry === void 0 ? void 0 : industry.industry;
  });
  var subIndustries = opportunity.industries.map(function (industry) {
    return industry === null || industry === void 0 ? void 0 : industry.subIndustry;
  });
  var jobFunctions = (0, _utils.getValuesWithCommaSeparator)(opportunity.jobFunctions, 'name').split(',');
  return /*#__PURE__*/_react.default.createElement(_styled4.Container, null, /*#__PURE__*/_react.default.createElement(_styled4.ImagesContainer, null, /*#__PURE__*/_react.default.createElement(_.Banner, {
    photo: opportunity === null || opportunity === void 0 ? void 0 : opportunity.photoUrl,
    editable: editable,
    onEdit: onEditBanner
  }), /*#__PURE__*/_react.default.createElement(_.Logo, {
    logo: opportunity === null || opportunity === void 0 ? void 0 : opportunity.logoUrl,
    editable: editable,
    onEdit: onEditLogo
  }), opportunity.qualified && /*#__PURE__*/_react.default.createElement(_styled4.Qualified, null)), durationsBand && /*#__PURE__*/_react.default.createElement(_styled4.DurationsBand, {
    color: (0, _utils.getBandColor)(opportunity.duration, (0, _lowerCase.default)(opportunity.type))
  }, /*#__PURE__*/_react.default.createElement(_styled4.Duration, {
    left: true
  }, (0, _utils.getDurationName)(opportunity.duration, (0, _lowerCase.default)(opportunity.type))), /*#__PURE__*/_react.default.createElement(_styled4.Duration, {
    right: true,
    $bsStyle: (0, _utils.getOpportunityEndDate)(opportunity).style
  }, (0, _utils.getOpportunityEndDate)(opportunity).label)), /*#__PURE__*/_react.default.createElement(_styled.Row, {
    center: true,
    $bsStyle: {
      flexWrap: 'wrap'
    }
  }, /*#__PURE__*/_react.default.createElement(_styled.Column, null, editable && showTitle ? /*#__PURE__*/_react.default.createElement(_styled.Row, null, /*#__PURE__*/_react.default.createElement(_styled2.TextBox, {
    name: "title",
    $bsStyle: {
      minWidth: '200px',
      marginTop: '10px',
      marginLeft: '80px'
    }
  }), /*#__PURE__*/_react.default.createElement(_styled3.CustomButton, {
    color: _constant.colors.ORANGE,
    onClick: function onClick() {
      return setShowTitle(false);
    },
    $bsStyle: {
      maxWidth: '100px',
      alignSelf: 'center',
      marginLeft: '10px'
    }
  }, "Save")) : /*#__PURE__*/_react.default.createElement(_styled4.OpportunityName, {
    $bsStyle: {
      fontWeight: "".concat(fontStyle)
    }
  }, (opportunity === null || opportunity === void 0 ? void 0 : opportunity.title) || 'Title of Position'), editable && /*#__PURE__*/_react.default.createElement(_.MessageError, {
    control: "title",
    $bsStyle: {
      backgroundColor: '#E99623',
      color: '#fff',
      fontWeight: 'bold',
      minWidth: '200px',
      height: 'auto',
      alignSelf: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      fontSize: '16px'
    }
  })), editable && !showTitle && /*#__PURE__*/_react.default.createElement(_styled.Column, {
    centered: true,
    $bsStyle: {
      marginLeft: '10px'
    }
  }, /*#__PURE__*/_react.default.createElement(_styled4.EditIcon, {
    onClick: function onClick() {
      return setShowTitle(!showTitle);
    }
  }))), company && showCompanyName && /*#__PURE__*/_react.default.createElement(_styled4.CompanyName, {
    onClick: goToCompany
  }, /*#__PURE__*/_react.default.createElement(_styled.Row, {
    center: true,
    $bsStyle: {
      maxWidth: '800px',
      width: '100%',
      alignItems: 'baseline'
    }
  }, /*#__PURE__*/_react.default.createElement(_styled4.CompanyPrefix, null, "Company:"), ' ', /*#__PURE__*/_react.default.createElement(_styled.Text, {
    $bsStyle: {
      color: _constant.colors.H_YELLOW,
      textDecoration: 'underline',
      margin: '0'
    }
  }, ((_opportunity$company = opportunity.company) === null || _opportunity$company === void 0 ? void 0 : _opportunity$company.name) || company.name))), !editable && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !(0, _isEmpty.default)(opportunity.opportunityForName) && [_constant.opportunityForEnums.INTERNAL_DIVISIONS, _constant.opportunityForEnums.SUBSIDIARY].includes(opportunity.opportunityFor) && /*#__PURE__*/_react.default.createElement(_styled.Row, {
    center: true,
    $bsStyle: {
      maxWidth: '800px',
      width: '100%',
      alignItems: 'baseline',
      flexWrap: 'wrap'
    }
  }, /*#__PURE__*/_react.default.createElement(_styled.Title, {
    $bsStyle: {
      marginRight: '3px',
      textTransform: 'uppercase'
    }
  }, "".concat(opportunity.opportunityFor === _constant.opportunityForEnums.SUBSIDIARY ? 'Subsidiary:' : 'Internal/Regional Division:')), /*#__PURE__*/_react.default.createElement(_styled.Text, null, opportunity.opportunityForName)), !(0, _isEmpty.default)(opportunity.locations) && /*#__PURE__*/_react.default.createElement(_styled.Row, {
    center: true,
    $bsStyle: {
      maxWidth: '800px',
      width: '100%',
      flexWrap: 'wrap',
      alignItems: 'baseline'
    }
  }, /*#__PURE__*/_react.default.createElement(_styled.Title, {
    $bsStyle: {
      marginRight: '5px',
      textTransform: 'uppercase'
    }
  }, opportunity.locations.length === 1 ? 'Location:' : 'Locations:'), opportunity.locations.length > 1 && /*#__PURE__*/_react.default.createElement(_styled.Title, {
    $bsStyle: {
      fontWeight: 400
    }
  }, "Multiple"), opportunity.locations.length === 1 && opportunity.locations.map(function (location) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: location.id
    }, /*#__PURE__*/_react.default.createElement(_opportunityLocation.default, {
      location: location,
      opportunityType: opportunity.type
    }));
  })), /*#__PURE__*/_react.default.createElement(_styled.Row, {
    center: true,
    $bsStyle: {
      maxWidth: '800px',
      width: '100%',
      flexWrap: 'wrap',
      alignItems: 'baseline'
    }
  }, /*#__PURE__*/_react.default.createElement(_styled.Title, {
    $bsStyle: {
      marginRight: '3px',
      textTransform: 'uppercase'
    }
  }, "Industry verticals:"), /*#__PURE__*/_react.default.createElement(_styled.Text, null, "".concat((0, _utils.getValuesWithCommaSeparator)((0, _sortBy.default)(industries, function (industry) {
    return industry.name;
  }), 'name', true)))), /*#__PURE__*/_react.default.createElement(_styled.Row, {
    center: true,
    $bsStyle: {
      maxWidth: '800px',
      width: '100%',
      flexWrap: 'wrap',
      alignItems: 'baseline'
    }
  }, /*#__PURE__*/_react.default.createElement(_styled.Title, {
    $bsStyle: {
      marginRight: '3px',
      textTransform: 'uppercase'
    }
  }, "Industries:"), /*#__PURE__*/_react.default.createElement(_styled.Text, null, "".concat((0, _utils.getValuesWithCommaSeparator)((0, _sortBy.default)(subIndustries, function (subIndustry) {
    return subIndustry.name;
  }), 'name')))), /*#__PURE__*/_react.default.createElement(_styled.Row, {
    center: true,
    $bsStyle: {
      maxWidth: '800px',
      width: '100%',
      flexWrap: 'wrap',
      alignItems: 'baseline'
    }
  }, jobFunctions[0].length !== 0 && /*#__PURE__*/_react.default.createElement(_styled.Title, {
    $bsStyle: {
      marginRight: '3px',
      textTransform: 'uppercase'
    }
  }, "Functions:"), jobFunctions.map(function (jobFunction, index) {
    return /*#__PURE__*/_react.default.createElement(_styled.Text, {
      key: "text-".concat(index),
      $bsStyle: {
        marginRight: '3px'
      }
    }, "".concat(jobFunctions.length - 1 > index ? "".concat(jobFunction, ",") : "".concat(jobFunction)));
  }))));
};
OpportunityBanner.propTypes = {
  opportunity: _utils.opportunityProps.isRequired,
  company: _utils.companyProps,
  onEditBanner: _propTypes.default.func,
  onEditLogo: _propTypes.default.func,
  goToCompany: _propTypes.default.func,
  editable: _propTypes.default.bool,
  showCompanyName: _propTypes.default.bool,
  fontStyle: _propTypes.default.string,
  durationsBand: _propTypes.default.bool
};
OpportunityBanner.defaultProps = {
  editable: false,
  showCompanyName: true,
  fontStyle: '',
  onEditBanner: undefined,
  onEditLogo: undefined,
  company: {},
  goToCompany: function goToCompany() {
    return {};
  },
  durationsBand: false
};
var _default = OpportunityBanner;
exports.default = _default;